import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselViewport,
} from "@loot-os/ui/components/carousel";
import { OpenCard } from "@loot-os/ui/components/open-card";

import type { RecentOpensContent } from "../../pages/home/content/recentOpens.js";
import { ClassicPullDialog } from "../ClassicPullDialog.js";
import { ClassicSection } from "../ClassicSection.js";

/** The design's "Fire Pulls" row. */
export function ClassicRecentOpens({ title, opens }: RecentOpensContent) {
  if (opens.length === 0) return null;

  return (
    <ClassicSection title={title}>
      <Carousel>
        <CarouselViewport>
          <CarouselPrevious className="hidden sm:flex" />
          <CarouselContent>
            {opens.map((pull) => (
              <CarouselItem key={pull.open.id} className="w-[calc(50%-0.5rem)] sm:w-48 lg:w-55">
                <ClassicPullDialog pull={pull}>
                  <OpenCard
                    item={pull.open.item}
                    rarityColor={pull.tierColor}
                    badge={pull.tierLabel}
                  />
                </ClassicPullDialog>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNext className="hidden sm:flex" />
        </CarouselViewport>
      </Carousel>
    </ClassicSection>
  );
}
